import { Button } from '@cad-arc';
import { isValidLatLng } from '../location/helpers';
import { useOpenSensorGridPanel } from './use-open-sensor-grid-panel';
import { useSensorsEnabled } from './use-sensors-enabled';

/**
 * Opens the sensor grid centred on an entity's location — the same panel cmd+click on the map
 * opens, so a dispatcher can get to nearby cameras from an event or a unit without hunting for
 * the spot by hand.
 *
 * Renders nothing when the feature is off or the entity has no usable coordinates: the grid ranks
 * cameras by distance from a point, so with no point there is nothing to offer.
 */
export function OpenSensorGridButton({
    latitude,
    longitude,
}: {
    latitude: number | undefined;
    longitude: number | undefined;
}): React.ReactElement | null {
    const sensorsEnabled = useSensorsEnabled();
    const openSensorGridPanel = useOpenSensorGridPanel();

    if (!sensorsEnabled || !isValidLatLng(latitude, longitude)) {
        return null;
    }

    return (
        // `flexGrow` rather than the `width: inherit` the ledger's other footer buttons use:
        // `inherit` resolves to the footer row's own `100%`, so two buttons each ask for the full
        // width and overflow it. Growing from a zero basis makes them share instead.
        <Button
            flexGrow={1}
            flexBasis={0}
            minWidth={0}
            data-testid="MAP_OPEN_SENSOR_GRID_BUTTON"
            onClick={() =>
                openSensorGridPanel({
                    latitude: latitude as number,
                    longitude: longitude as number,
                })
            }
        >
            Open sensor grid
        </Button>
    );
}
